module.exports = __webpack_public_path__ + "img/map-marker-current-lh.e856815d.png";